import { isNil } from './func';

export function isTargetDescendant(event: Event, parent?: HTMLElement | null) {
    return !isNil(parent) && event.composedPath().includes(parent);
}

export function addEventListenerOnTransitionEnded(
    element: HTMLElement | undefined | null,
    fn: EventListenerOrEventListenerObject
) {
    if (!element) {
        return false;
    }

    element.addEventListener('transitionend', fn);
    return true;
}

export function removeEventListenerOnTransitionEnded(
    element: HTMLElement | undefined | null,
    fn: EventListenerOrEventListenerObject
) {
    if (!element) {
        return false;
    }

    element.removeEventListener('transitionend', fn);
    return true;
}
